<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">
      {{ 'pii.details.approve.sagaConfirm.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      (click)="dismiss(0)"
    ></i>
  </div>
  <div class="modal-body">
    <app-data-table [configuration]="configuration"></app-data-table>
  </div>

  <div class="modal-footer">
    <button class="btn btn-clear" (click)="dismiss(0)">
      {{ 'pii.details.approve.sagaConfirm.buttons.cancel' | translate }}
    </button>
    @if (!state.errors?.length) {
      <button ngbAutoFocus class="btn btn-primary ms-2" (click)="dismiss(1)">
        {{
          'pii.details.approve.sagaConfirm.buttons.approveAnyway' | translate
        }}
      </button>
    }
  </div>
</div>
